<template>
  <div style="height:100%;">
    <!-- 筛选 -->
    <el-card shadow='never'>
      <span v-if="trip_plan_id == ''">
        <el-button size="mini"
                   @click="showTripPlanList"
                   type="primary">选择方案</el-button>
      </span>
      <span v-else>
        <el-button size="mini"
                   @click="showTripPlanList"
                   type="primary">当前方案：{{trip_plan_id}}{{trip_plan_name}}</el-button>
      </span>
      <!-- 账号类型 -->
      <span style="margin-left:25px">当前账号:
        <span v-if="is_staff">定制师</span>
        <span v-else>管理员</span>
      </span>
      <!-- 清空缓存 -->
      <span style="float:right">
        <el-button type="text"
                   @click="emptyReservationList">更新产品数据</el-button>
      </span>

    </el-card>
    <!-- 产品列表选项 -->
    <!-- 修改表格宽度： -->
    <el-card shadow='never'
             v-loading="loading">
      <!-- 仅显示已选项 -->
      <div style="margin-bottom:10px;display:flex;justify-content:space-between">
        <div>
          <el-button size="mini"
                     @click="addProductItem">+添加项目</el-button>
          <!-- 仅显示一选项 -->
          <span style="margin-left:20px">仅显示已选项：</span>

          <el-switch v-model="showSelectOpen"
                     @change="showSelectItem">
          </el-switch>
          <!-- 显示优惠修改 -->
          <span style="margin-left:20px">可添加优惠价：</span>
          <el-switch v-model="showDiscountPrice">
          </el-switch>
          <!-- 显示优惠修改 -->
          <span style="margin-left:20px">滚动到：</span>
          <el-link size="mini"
                   style="font-size:5pt;margin-right:5pt"
                   :underline="false"
                   @click="scrollBottom">底部</el-link>
          <el-link size="mini"
                   style="font-size:5pt;"
                   :underline="false"
                   @click="pagingScrollTopLeft(0)">顶部</el-link>

        </div>

      </div>
      <div style="display:flex; justify-content:space-between ">
        <!-- 统计区域 -->
        <div class="account_for_your_trip">
          <!-- 须知 -->
          <div class="account_for_your_trip_border">
            <p style="font-weight:900">【说明】</p>
            <p>● 以下是旅行中涉及的相关服务及玩乐费用</p>
            <p>● 这些服务可提升旅行体验、及便捷，可根据自身实际情况选择，如有其他需求可随时联系我们。
            </p>
            <p>● 相关费用均比当地价格优惠，支持全网比价</p>
            <p>**仅提供该产品的代订及对接服务，具体的旅游服务和操作由当地服务商提供</p>
          </div>

          <!-- 费用 -->
          <div class="account_for_your_trip_border"
               style="background:rgba(255,251,240,0.2);margin-left:10px;">
            <p style="margin-right:15px"
               class="account_for_your_trip_title">玩乐花费合计：¥ {{(all_sell_price/100).toFixed(2)}}</p>
            <!-- 优惠额度 -->
            <div v-if="showDiscountPrice">
              <p style="font-size:10px"
                 class="account_for_your_trip_title">优惠：- ¥ {{(all_sell_price/100).toFixed(2)-(all_discount_price/100).toFixed(2)}}</p>
              <!-- 优惠后 -->
              <el-popover @hide="hidePopver"
                          v-model="changAllDiscountVisible"
                          trigger="click"
                          placement="top"
                          width="200">
                <p>
                  优惠价:{{(all_discount_price/100).toFixed(2)}}
                </p>
                <!-- 打折、减钱 -->
                <div style="margin-top: 10px; dispay: inline">
                  <el-input :placeholder="placeholderType"
                            v-model="discountValue"
                            @blur="blurDiscountInput"
                            size="mini"
                            class="input-with-select">
                    <el-select v-model="selectDiscountMode"
                               slot="prepend"
                               style="width:80px"
                               @change="confirmDiscountMode"
                               placeholder="请选择">
                      <el-option label="减钱"
                                 value="1"></el-option>
                      <el-option label="折扣"
                                 value="2"></el-option>
                    </el-select>
                    <template v-if="selectDiscountMode==2"
                              slot="append">%</template>

                  </el-input>
                  <!--  -->
                  <div style="float:right">
                    <!-- <el-input v-model="new_all_discount_price"
                            style="width: 100px; margin-right: 10px"
                            size="mini">输入框</el-input> -->
                    <el-button size="mini"
                               type="text"
                               @click="showInputnewAccount = true">取消</el-button>
                    <el-button type="text"
                               size="mini"
                               @click="changeDiscountAllPrice()">确定</el-button>
                  </div>
                </div>
                <!-- 外部按钮 -->
                <p slot="reference"
                   class="account_for_your_trip_title">实际应付：¥ {{(all_discount_price/100).toFixed(2)}}</p>
              </el-popover>
            </div>
          </div>
          <!-- logo -->
          <el-image style="width: 100px; height: 100px; padding:10px 50px"
                    src="http://szsxtravel.top/logo.png"
                    fit="fil"></el-image>
        </div>
        <!-- 改数量，看利润 -->
        <div class="account_for_your_trip"
             style="flex:1;margin-left:10px">

          <div class="account_for_your_trip_border"
               style="background:rgba(255,251,240,0.2);width:100%">

            <!-- 批量修改数量 -->
            <span style="margin-right:20px">
              <el-popover @hide="hidePopver"
                          v-model="popoverProductNum"
                          trigger="click"
                          placement="top"
                          width="200">
                <p>
                  预订数量为:
                </p>
                <el-button v-if="showChangeProductNum"
                           size="mini"
                           type="text"
                           @click="changeProductNum()">修改数量</el-button>
                <div style="margin-top: 10px; dispay: inline"
                     v-else>
                  <el-input v-model="reservation_account"
                            @change="submitProductNum()"
                            style="width: 100px; margin-right: 10px"
                            size="mini">输入框</el-input>
                  <el-button type="text"
                             size="mini"
                             @click="submitProductNum()">确定</el-button>
                </div>
                <!-- 外部按钮 -->
                <span slot="reference">
                  批量修改已选数量：{{reservation_account}} <i class="el-icon-edit"></i>
                </span>
              </el-popover>

            </span>
            <!-- 利润 -->

            <span v-if="is_staff">
              <!-- <span>可赚:{{all_staff_get}}</span> -->
            </span>
            <span v-else>
              <!-- <span style="margin-right:20px">可赚:{{(all_staff_get/100).toFixed(2)}}</span> -->
              <div style="margin-right:20px">利润:{{(all_profit/100).toFixed(2)}}</div>
              <div style="margin-right:20px">成本:{{(all_cost/100).toFixed(2)}}</div>
            </span>

          </div>

        </div>
      </div>
      <!-- 数据表格 -->
      <u-table ref="multipleTable"
               @select="handleSelectionChange"
               :data="tableData"
               :height="tableHeight"
               use-virtual
               row-key="sku_id"
               :row-height="30"
               :header-row-style="{height:'20pt'}"
               :header-cell-style="{padding:'0',backgroundColor:'#FF5421',color:'#FFF',fontSize:'10px'}"
               :cell-style="{padding:'0',fontSize:'8px',color:'black'}"
               border>
        <!-- 多选框 -->
        <u-table-column type="selection"
                        :reserve-selection="true" />
        <!-- 产品名 -->
        <u-table-column label="产品名"
                        show-overflow-tooltip
                        width="250"
                        :filters="city_list"
                        :filter-method="filterHandler"
                        filter-placement="top">
          <template slot-scope="sku">
            <!-- 服务商 -->
            <el-tooltip class="item"
                        effect="light"
                        :content="sku.row.operator"
                        placement="top-end">
              <i class="el-icon-info"></i>

            </el-tooltip>
            <!-- 目的地 -->【
            <span v-for="item,index in sku.row.dest"
                  :key="index">{{item }} <span v-if="index+1!==sku.row.dest.length">|</span></span>】
            <!-- 套餐名称 -->
            {{sku.row.spu_name}}
          </template>
        </u-table-column>
        <!-- 套餐名称 -->
        <u-table-column label="套餐"
                        show-overflow-tooltip
                        width="320">
          <template slot-scope="sku">
            {{sku.row.sku_name}}
          </template>
        </u-table-column>
        <!-- 规格 -->
        <u-table-column width="60"
                        align="center"
                        label="规格">
          <!-- <template slot-scope="sku">{{sku.row.type}}</template> -->
          <template slot-scope="sku">
            <el-popover @hide="hidePopver"
                        trigger="click"
                        placement="top"
                        width="200">
              <p>
                修改规格名称:
              </p>
              <div style="margin-top: 10px; dispay: inline">
                <el-input v-model="newTypeName"
                          @change="submitNewTypeName(sku.row)"
                          style="width: 200px; margin-right: 10px"
                          size="mini">输入框</el-input>
              </div>
              <!-- 外部按钮 -->
              <el-button size="mini"
                         type="text"
                         slot="reference">
                {{sku.row.type}}
              </el-button>
            </el-popover>
          </template>
        </u-table-column>
        <!-- 原价 -->
        <u-table-column width="80"
                        align="right"
                        label="原价">
          <template slot-scope="sku">{{(sku.row.price/100).toFixed(2)}}</template>
        </u-table-column>
        <!-- 单价 -->
        <u-table-column width="80"
                        align="right"
                        label="优惠价">
          <!-- <template slot-scope="sku">{{(sku.row.sell_price/100).toFixed(2)}}</template> -->
          <template slot-scope="sku">
            <el-popover @hide="hidePopver"
                        trigger="click"
                        placement="top"
                        width="200">
              <p>
                修改单价（临时修改）:{{(sku.row.sell_price/100).toFixed(2)}}
              </p>
              <el-button v-if="showInputSellPrice"
                         size="mini"
                         type="text"
                         @click="changeProdectSellPrice(sku.row)">修改</el-button>
              <div style="margin-top: 10px; dispay: inline"
                   v-else>
                <el-input v-model="newSellPrice"
                          @change="submitNewSellPrice(sku.row)"
                          style="width: 100px; margin-right: 10px"
                          size="mini">输入框</el-input>
                <el-button size="mini"
                           type="text"
                           @click="showInputnewAccount = true">取消</el-button>
                <el-button type="text"
                           size="mini"
                           @click="submitNewSellPrice(sku.row)">确定</el-button>
              </div>
              <!-- 外部按钮 -->
              <el-button size="mini"
                         type="text"
                         slot="reference">
                {{(sku.row.sell_price/100).toFixed(2)}}
              </el-button>
            </el-popover>
          </template>
        </u-table-column>
        <!-- ---- 修改数量 ----- -->
        <u-table-column width="80"
                        align="center"
                        label="数量">
          <template slot-scope="sku">
            <el-popover @hide="hidePopver"
                        trigger="click"
                        placement="top"
                        width="200">
              <p>
                修改预订数量:{{sku.row.num}}
              </p>
              <el-button v-if="showInputnewAccount"
                         size="mini"
                         type="text"
                         @click="changeBookingDetialNetPrice(sku.row)">修改预订数量</el-button>
              <div style="margin-top: 10px; dispay: inline"
                   v-else>
                <el-input v-model="newAccount"
                          @change="submitNewAccount(sku.row)"
                          style="width: 100px; margin-right: 10px"
                          size="mini">输入框</el-input>
                <el-button size="mini"
                           type="text"
                           @click="showInputnewAccount = true">取消</el-button>
                <el-button type="text"
                           size="mini"
                           @click="submitNewAccount(sku.row)">确定</el-button>
              </div>
              <!-- 外部按钮 -->
              <el-button size="mini"
                         type="text"
                         slot="reference">
                {{ sku.row.num }}
              </el-button>
            </el-popover>
          </template>
        </u-table-column>
        <!-- 金额 -->
        <u-table-column width="80"
                        align="right"
                        label="金额">
          <template slot-scope="sku">{{(sku.row.num*sku.row.sell_price/100).toFixed(2)}}</template>

        </u-table-column>
        <!-- 空 -->
        <u-table-column align="right"
                        label="">

        </u-table-column>
        <!-- 底价 -->
        <u-table-column v-if="!is_staff"
                        width="80"
                        align="right"
                        label="底价">
          <template slot-scope="sku">
            <span v-if="showModifyNetPrict==sku.row.sku_id">
              <el-input size="mini"
                        :ref="'modifyNetPrice'+sku.row.sku_id"
                        @blur="showModifyNetPrict=null"
                        :placeholder="(sku.row.net_price/100).toFixed(2)"
                        v-model="sku.row.net_price"></el-input>
            </span>
            <span v-else
                  @click="showModifyNetInput(sku.row.sku_id)">{{(sku.row.net_price/100).toFixed(2)}}
            </span>

          </template>
        </u-table-column>
        <!-- 其他 -->
        <u-table-column v-else
                        align="right"
                        label="其他">
        </u-table-column>
        <!-- 单利 -->
        <u-table-column v-if="!is_staff"
                        width="80"
                        align="right"
                        label="单利">
          <template slot-scope="sku">
            {{((sku.row.sell_price-sku.row.net_price)/100).toFixed(2)}}</template>
        </u-table-column>
        <!-- 其他 -->
        <u-table-column v-else
                        align="right"
                        label="其他">
        </u-table-column>
        <!-- 合利 -->
        <u-table-column v-if="!is_staff"
                        width="80"
                        align="right"
                        label="利润">
          <template slot-scope="sku">
            {{((sku.row.sell_price-sku.row.net_price)*sku.row.num/100).toFixed(2)}}</template>
        </u-table-column>
        <!-- 其他 -->
        <u-table-column v-else
                        align="right"
                        label="其他">

        </u-table-column>
        <!-- 查看服务商 -->
        <u-table-column width="160"
                        show-overflow-tooltip
                        align="center"
                        label="服务商">
          <template slot-scope="item">
            <!-- <el-tooltip class="item"
                        effect="light"
                        :content="item.row.operator"
                        placement="top-end">
              <i class="el-icon-info"></i>

            </el-tooltip> -->
            <i style="margin-left:10%;cursor: pointer;"
               @click="checkProductInfo(item.row)"
               class="el-icon-document"></i>
            {{item.row.operator}}
          </template>
        </u-table-column>
      </u-table>

    </el-card>
    <!-- 选择方案的对话框 -->
    <el-dialog title="选择方案"
               :visible.sync="dialogVisibleTripPlan"
               width="70%">
      <div v-loading="loadingDialog">
        <!-- 列表 -->
        <div>
          <span>选中相应方案，点击绑定即可将清单绑定给此方案。对于已绑定方案可点击查看按钮进行查看/修改</span>
          <el-table :data="TripPlanList"
                    highlight-current-row
                    @current-change="handleCurrentChange"
                    style="width: 100%">
            <el-table-column prop="id"
                             label="方案ID"
                             align="center"
                             width="80">
            </el-table-column>
            <el-table-column prop="plan_name"
                             show-overflow-tooltip
                             label="行程名称"
                             align="left"
                             width="240">
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             label="日行程包含">
              <template slot-scope="item">
                <el-popover placement="right"
                            @show="showDayTripRoute(item.row)"
                            @hide="emptyDayDetailList"
                            :title="`行程概况--行程码：`+ trip_code"
                            width="auto"
                            trigger="click">
                  <!-- begin item.row.day_detail_list-->

                  <div v-for="dayItem,index of day_detail_list"
                       :key="index">

                    第{{index+1}}天：
                    <div style="font-size:10px"
                         v-for="item,index of dayItem.overview"
                         :key="index">
                      <!-- 整日 -->
                      <div v-if="item.trip_type =='all_day'">
                        <span class="">整日</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 离开 -->
                      <div v-if="item.trip_type =='departure'">
                        <span class="">离开</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 中转 -->
                      <div v-if="item.trip_type =='transit'">
                        <span class="">中转</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 抵达 -->
                      <div v-if="item.trip_type =='arrival'">
                        <span class="">抵达</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                    </div>
                  </div>
                  <!-- off -->
                  <div slot="reference">共{{item.row.days}}天行程【{{item.row.start_date}}】:

                    <!-- 方案目的地 -->
                    <span v-for="dest_name,index in item.row.dest_name"
                          :key="index">{{dest_name}} <span v-if="item.row.dest_name.length!=index+1">, </span></span>
                    <!-- 是否 预算 -->

                  </div>
                </el-popover>

              </template>
            </el-table-column>
            <el-table-column prop="start_date"
                             width="100"
                             label="查看">
              <template slot-scope="item">
                <el-button size="mini"
                           type="primary"
                           @click="checkPlanCost(item.row)"
                           v-if="item.row.has_cost == 1"> <i class="el-icon-success">已绑定</i> </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- ----------------- 分页 ------------------ -->
        <div class="pagination">
          <el-pagination @current-change="handleCurrentChange_system"
                         :small="true"
                         background
                         layout="prev, pager, next,total"
                         :current-page.sync="pagenum_system"
                         :page-size="pagesize"
                         :total="page_account"></el-pagination>
        </div>
      </div>
      <!-- 按钮 -->
      <span slot="footer"
            class="dialog-footer">
        <el-button size="mini"
                   @click="cancleDialogVisibleTripPlan">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="bandTripPlanAndReservationForm">绑 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加项目 -->
    <el-dialog :title="'添加付费项目'+ new_sku_id"
               :visible.sync="addProductItemDialog"
               width="40%">

      <el-form label-position="left"
               label-width="80px"
               :model="new_product_item">
        <!--  -->
        <el-form-item label="目的地">
          <el-input size="mini"
                    v-model="new_product_item_dest"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input size="mini"
                    v-model="new_product_item.spu_name"></el-input>
        </el-form-item>
        <el-form-item label="套餐名称">
          <el-input size="mini"
                    v-model="new_product_item.sku_name"></el-input>
        </el-form-item>
        <el-form-item label="规格">
          <el-input size="mini"
                    v-model="new_product_item.type"></el-input>
        </el-form-item>
        <el-form-item label="单价">
          <el-input size="mini"
                    v-model="new_product_item.sell_price"></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input size="mini"
                    v-model="new_product_item.num"></el-input>
        </el-form-item>
        <el-form-item label="合作价">
          <el-input size="mini"
                    v-model="new_product_item.net_price"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="addProductItemDialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitProductItem()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let screenHeight = window.innerHeight
// console.log(screenHeight)
import { createLogger } from 'vuex'
export default {
  name: 'reservation_form',
  data() {
    return {
      dialogVisibleTripPlan: false, // 选择方案对话框
      addProductItemDialog: false, // 添加付费项目
      TripPlanList: [],
      day_detail_list: [],
      trip_code: '',
      // 分页
      pagesize: 8,
      pagenum_system: 1,
      page_account: null,
      trip_plan_name: '',
      trip_plan_id: '',
      // 弹出框
      popoverProductNum: false,
      loading: false,
      loadingDialog: false,
      is_staff: null,
      // 批量修改数量
      reservation_account: 0,
      showChangeProductNum: false,
      // 显示已选项
      showSelectOpen: false,
      showDiscountPrice: true, // 总价基础上显示优惠价

      tableData: [],
      productData: [],
      selectData: [],
      costRemark: '',
      showInputSellPrice: false,
      showInputnewAccount: false,
      newTypeName: '',
      newAccount: null,
      newSellPrice: null,
      // 统计：
      changAllDiscountVisible: false,
      all_sell_price: null, // 玩乐总价
      all_discount_price: null, // 实际应付/
      selectDiscountMode: null,
      placeholderType: null, // 折扣类型
      discountValue: null, // 折扣数
      new_all_discount_price: null, // 折扣修改
      all_cost: null,
      all_profit: null,
      all_staff_get: null,
      //
      new_sku_id: 1,
      new_product_item_dest: '',
      new_product_item: {
        dest: [],
        sku_name: '',
        spu_name: '',
        type: '/',
        num: 0,
        price: null,
        sell_price: null,
        net_price: null,
        operator_id: null,
        operator: null,
        sku_id: null,
        sku_status: true,
        spu_id: null,
        stock_type: true,
      },
      // 修改低价
      showModifyNetPrict: null,
      new_net_price: null,
      // 表高度
      tableHeight: screenHeight - 20,
      city_list: [],
    }
  },
  mounted() {
    this.getProductInfo()
  },
  methods: {
    // 折扣
    confirmDiscountMode() {
      if (this.selectDiscountMode == 1) {
        this.placeholderType = '0.00'
      } else if (this.selectDiscountMode == 2) {
        // this.placeholderType = '折扣范围：1-10'
        this.placeholderType = '0'
      }
    },
    // 滚动
    scrollBottom() {
      this.$refs.multipleTable.scrollBottom()
    },
    pagingScrollTopLeft(val) {
      this.$refs.multipleTable.pagingScrollTopLeft(val, 0)
    },
    // 筛选
    filterHandler(value, row, column) {
      this.loading = true
      // console.log('value', value)
      // console.log('text', row.dest.toString())
      // console.log('list', row.dest.toString().split(','))
      let newStr = row.dest.toString().split(',').indexOf(value)
      // console.log(newStr)
      setTimeout(() => {
        this.loading = false
      }, 200)

      return row.dest.toString() == value || newStr != -1
      // row.dest.forEach((item) => {
      //   console.log(item)
      //   if (item == value) {
      //     console.log(item, '一样')
      //     return item === value
      //   }
      // })
    },
    // 打开产品链接
    checkProductInfo(row) {
      let routeData = this.$router.resolve({
        path: `/product-intro`,
        query: { spu_id: `${row.spu_id}` },
      })
      window.open(routeData.href, '_blank')
    },
    // 打开添加项目对话框
    addProductItem() {
      this.addProductItemDialog = true
      console.log('打开对话框')
      // 随机生成一个ID
      this.new_sku_id = this.new_sku_id + 1
      this.new_product_item = {
        dest: [],
        sku_name: '',
        spu_name: '',
        type: '/',
        num: 0,
        price: null,
        sell_price: null,
        net_price: null,
        operator_id: null,
        operator: null,
        sku_id: 'a' + this.new_sku_id,
        sku_status: true,
        spu_id: null,
        stock_type: true,
      }
    },
    // 提交添加项目
    submitProductItem() {
      this.new_product_item.dest.push(this.new_product_item_dest)
      // 处理数据
      this.new_product_item.price = this.new_product_item.sell_price * 100
      this.new_product_item.net_price = this.new_product_item.net_price * 100
      this.new_product_item.sell_price = this.new_product_item.sell_price * 100
      // console.log(this.new_product_item)
      this.tableData.push(this.new_product_item)
      // 设置为已选项
      this.$refs.multipleTable.toggleRowSelection([
        { row: this.new_product_item, selected: true },
      ])
      // 加入到已选列表
      this.selectData.push(this.new_product_item)
      this.$refs.multipleTable.scrollBottom()
      // 新的 条目
      this.addProductItemDialog = false
    },

    // 获取方案
    getAllTripPlanList() {
      this.loadingDialog = true
      this.$http
        .get(
          `/traver/get_trip_plan_list?page_size=${this.pagesize}&page_number=${this.pagenum_system}`
        )
        .then((res) => {
          const { errno, errmsg, data } = res.data
          this.page_account = res.data.page_account
          if (errno == '0') {
            this.TripPlanList = data
            this.loadingDialog = false
          } else {
            this.$message({
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    // 日细节
    showDayTripRoute(item) {
      // console.log(item)
      this.$http
        .get(`/traver/get_day_plan_detail_of_overview?plan_id=${item.id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.day_detail_list = res.data.data
            this.trip_code = res.data.code
          }
        })
    },
    emptyDayDetailList() {
      this.day_detail_list = []
    },
    // 分页
    handleCurrentChange_system(page) {
      this.TripPlanList = []
      this.pagenum_system = page
      this.getAllTripPlanList()
    },
    // 选择方案
    handleCurrentChange(item) {
      if (item) {
        // 判断是否有方案
        this.$http
          .get(`/traver/get_trip_plan_cost?trip_plan_id=${item.id}`)
          .then((res) => {
            if (item.has_cost == 0) {
              this.trip_plan_name = item.plan_name
              this.trip_plan_id = item.id
            } else {
              // this.selectData = item.plan_cost
              this.trip_plan_name = item.plan_name
              this.trip_plan_id = item.id
            }
          })
      }
    },
    // 查看方案费用
    checkPlanCost(item) {
      this.dialogVisibleTripPlan = false
      this.selectData = item.plan_cost
      this.showSelectOpen = true
      this.tableData = this.selectData
      this.$nextTick((_) => {
        this.selectData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
        this.coastAllSelectProduce()
        // 如果item.discount_cost（之前有设置优惠） 不为空重新计算例如
        if (item.discount_cost) {
          this.all_discount_price = item.discount_cost
          this.all_profit = this.all_discount_price - this.all_cost
        }
      })
    },
    // 取消选择方案：
    cancleDialogVisibleTripPlan() {
      this.dialogVisibleTripPlan = false
      this.trip_plan_id = ''
    },
    // 绑定方案和价格表
    bandTripPlanAndReservationForm() {
      let post_item = {
        trip_plan_id: this.trip_plan_id,
        plan_cost: this.selectData,
        discount_cost: this.all_discount_price,
        cost_remark: this.costRemark,
      }
      this.$http
        .post('/traver/cost_band_to_trip_plan', post_item)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
          } else {
            this.$message({
              type: 'errno',
              message: res.data.errmsg,
            })
          }
        })
    },
    showTripPlanList() {
      this.dialogVisibleTripPlan = true
      this.loadingDialog = true
      // 获取方案列表
      this.getAllTripPlanList()
    },
    changeProductNum() {},
    // 提交总数量
    submitProductNum() {
      this.selectData.forEach((res) => {
        res.num = this.reservation_account
      })
      this.coastAllSelectProduce()
      this.popoverProductNum = false
    },
    // 计算总价：
    coastAllSelectProduce() {
      this.all_sell_price = null
      this.all_cost = null
      this.all_profit = null
      this.selectData.forEach((item) => {
        this.all_sell_price += item.sell_price * item.num
        this.all_discount_price = this.all_sell_price
        this.all_cost += item.net_price * item.num
      })
      this.all_profit = this.all_discount_price - this.all_cost
    },
    // 折扣输入框失焦
    blurDiscountInput() {
      console.log('执行')
      this.changeDiscountAllPrice()
    },
    // 修改优惠价
    changeDiscountAllPrice() {
      if (this.selectDiscountMode == 1) {
        // 减钱
        if (this.all_sell_price != 0) {
          let discountNum = this.discountValue * 100
          this.new_all_discount_price = this.all_sell_price - discountNum
          console.log('折扣金额', discountNum)
          console.log('售价：', this.all_sell_price)
          console.log('新折扣价：', this.new_all_discount_price)
          this.all_discount_price = this.new_all_discount_price
          this.changAllDiscountVisible = false
        } else {
          this.new_all_discount_price = this.all_sell_price - this.discountValue
        }
      } else if (this.selectDiscountMode == 2) {
        // 折扣
        console.log(this.discountValue)
        let discountNum = this.discountValue / 100
        this.new_all_discount_price = this.all_sell_price * (1 - discountNum)
        console.log('折扣金额', discountNum)
        console.log('售价：', this.all_sell_price)
        console.log('新折扣价：', this.new_all_discount_price)
        this.all_discount_price = this.new_all_discount_price
        this.changAllDiscountVisible = false
      } else {
        this.$message({
          type: 'error',
          message: '请选择折扣方式',
        })
      }
      this.all_profit = this.all_discount_price - this.all_cost
    },
    // 修改 底价 输入框
    showModifyNetInput(sku_id) {
      this.showModifyNetPrict = sku_id
      let _this = this
      setTimeout(function () {
        _this.$refs['modifyNetPrice' + sku_id].focus()
      }, 1)
    },
    // 隐藏弹出框[全部]
    hidePopver() {
      this.showInputnewAccount = true
      this.showInputSellPrice = true
      this.newAccount = undefined
      this.newSellPrice = undefined
    },
    // 临时修改单价
    changeProdectSellPrice() {
      this.showInputSellPrice = false
    },
    submitNewTypeName(item) {
      item.type = this.newTypeName
    },
    // 提交修改售价
    submitNewSellPrice(item) {
      item.sell_price = this.newSellPrice * 100
      this.showInputSellPrice = false
      this.coastAllSelectProduce()
    },
    // 修改数量
    changeBookingDetialNetPrice() {
      this.showInputnewAccount = false
    },

    // 提交修改-数量
    submitNewAccount(item) {
      item.num = this.newAccount
      this.showInputnewAccount = false
      this.coastAllSelectProduce()
    },
    // 获取价格表
    getProductInfo() {
      this.loading = true
      this.$http.get(`/product/make_reservation_form`).then((res) => {
        if (res.data.errno == '0') {
          this.productData = res.data.data
          this.tableData = this.productData
          // 配置筛选目的地
          this.tableData.forEach((item) => {
            if (item.dest.length == 1) {
              let filter_item = {
                text: item.dest[0],
                value: item.dest[0],
              }
              this.city_list.push(filter_item)
            } else {
              item.dest.forEach((dest_item) => {
                let filter_item = {
                  text: dest_item,
                  value: dest_item,
                }
                this.city_list.push(filter_item)
              })
            }
          })
          let obj = this.city_list
          // 去重
          var uniques = []
          var stringify = {}
          for (var i = 0; i < obj.length; i++) {
            var keys = Object.keys(obj[i])
            // 排序
            keys.sort(function (a, b) {
              return Number(a) - Number(b)
            })
            var str = ''
            for (var j = 0; j < keys.length; j++) {
              str += JSON.stringify(keys[j])
              str += JSON.stringify(obj[i][keys[j]])
            }
            if (!stringify.hasOwnProperty(str)) {
              uniques.push(obj[i])
              stringify[str] = true
            }
          }
          uniques = uniques
          this.city_list = uniques
          // console.log(uniques)

          //
          this.is_staff = res.data.is_staff
          this.loading = false
        } else {
          this.$messagt({
            type: 'error',
            message: res.data.errmsg,
          })
          this.loading = false
        }
      })
    },
    // 选择时
    handleSelectionChange(val) {
      console.log(val)

      console.log('数量为0')
      val.forEach((res) => {
        if (res.num == 0) {
          res.num = this.reservation_account
        }
      })

      this.selectData = val
      // console.log('选择了：', val)
      this.coastAllSelectProduce()
    },
    // 仅显示一选项de开关
    showSelectItem() {
      if (this.showSelectOpen == true) {
        this.tableData = this.selectData
        // this.$refs.multipleTable.toggleAllSelection()
      } else if (this.showSelectOpen == false) {
        this.tableData = this.productData
        // this.$nextTick((_) => {
        //   this.selectData.forEach((row) => {
        //     this.$refs.multipleTable.toggleRowSelection(row, true)
        //   })
        // })
      }
    },
    emptyReservationList() {
      this.$http.get(`/product/renew_redis_reservation_form`).then((res) => {
        if (res.data.errno == '0') {
          this.$message({
            type: 'success',
            message: '刷新中... 请稍等',
          })
          this.getProductInfo()
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
  },
}
</script>

<style>
/* 重新定义筛选时的表头样式 */
.el-table th > .cell.highlight {
  color: #ff5421;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.account_for_your_trip {
  background-color: #ff5421;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: #fff;
}
.account_for_your_trip_border {
  border-radius: 5px;
  border: 1px solid #fff;
  padding: 10px;
}
.account_for_your_trip_title {
  font-size: larger;
  font-weight: bolder;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>
